import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: false
  },
  mutations: {
    SET_USER (state, status) {
      state.user = status
    }
  },
  actions: {
    registerNewPlayer (context) {
      context.commit('SET_USER', true)
    }
  },
  modules: {
  }
})
